var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTitleBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 56,
    viewBox: "0 0 161 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.371 8.70884C160.952 11.1308 159.521 14.0677 156.051 17.3669C152.611 20.637 147.302 24.1303 140.501 27.6331C126.906 34.6349 107.454 41.6228 85.3683 46.9258C63.2831 52.2289 42.7786 54.8353 27.4869 54.7696C19.837 54.7367 13.5205 54.0349 8.97079 52.6833C4.38057 51.3196 1.77217 49.3526 1.19061 46.9306C0.609062 44.5087 2.03996 41.5718 5.51054 38.2725C8.95047 35.0025 14.2597 31.5092 21.0606 28.0064C34.6553 21.0045 54.1077 14.0167 76.193 8.71363C98.2782 3.41059 118.783 0.804131 134.074 0.869902C141.724 0.902805 148.041 1.60456 152.591 2.9562C157.181 4.31988 159.789 6.28689 160.371 8.70884Z",
    stroke: "#FAFF0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleBg);
export default __webpack_public_path__ + "static/media/title-bg.7f0afe90869a826844459c215e06a324.svg";
export { ForwardRef as ReactComponent };